//React dependencies
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

//Action dependencies
import { addEquipmentNote, updateEquipmentNote, deleteEquipmentNote, getEquipmentNotes } from "../../store/actions/EquipmentNotesAction";
import { getEquipmentFiles, deleteEquipmentFiles } from "../../store/actions/EquipmentAction";
import { getUserInfo } from "../../store/actions/userActions";

//Component dependencies
import { getSelectedFileNames } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import TableButtons from "../../components/Button/TableButtons";
import Modal from "../../components/Modal/Modal";
import AddButton from "../../components/AddButton/AddButton";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import SearchBar from "../../components/SearchBar/SearchBar";
import "./style.css";

//MUI dependencies
import {
    Grow,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    FormHelperText,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
} from "@mui/material";
import { ArrowForwardIos, CloudDownload } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import { FcInfo } from "react-icons/fc";

//Other NPM dependencies
import moment from "moment";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((_theme) => ({
    root: {
        marginTop: 10,
        fontSize: "0.7125rem",
    },
}));

export default function EquipmentNotes(props) {
    const classes = useStyles();
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const location = useLocation();

    //Sorting states
    const [sortOrder, setSortOrder] = useState(0);
    const [sortColumn, setSortColumn] = useState("");

    //Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [editable, setEditable] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    const [initialRows, setInitialRows] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    let [rows, setRows] = useState([]);
    const [equipmentName, setEquipmentName] = useState("");
    const [userId, setUserId] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [noteDetails, setNoteDetails] = useState("");
    const [rowsLength, setRowsLength] = useState(0);

    const {
        user: { userInformation },
    } = useSelector((user) => user);
    const { equipmentNotes, isTaskUpdated } = useSelector(({ equipmentNotesReducer }) => equipmentNotesReducer);
    const { equipment } = useSelector((state) => state);

    const getUserId = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        let userCode = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
        dispatch(getUserInfo(userCode));
    };

    useEffect(() => {
        if (userInformation?.resultObject) {
            const { resultObject } = userInformation;
            setUserId(resultObject.mostUserId);
        }
    }, [userInformation]);

    useEffect(() => {
        LoadHandler();
        getUserId();
    }, []);

    useEffect(() => {
        if (isTaskUpdated) {
            LoadHandler();
        }
    }, [isTaskUpdated]);

    useEffect(() => {
        if (equipmentNotes?.data) {
            if (equipmentNotes?.data.resultObject.content.length > 0) {
                setRows(Object.values(equipmentNotes?.data.resultObject.content));
                setInitialRows(cloneObject(Object.values(equipmentNotes?.data.resultObject.content)));
                setRowsLength(equipmentNotes?.data.resultObject.totalCount);
                setEditableRow(false);
                setEditable(false);
                setDisableButton(false);
            } else {
                setRows([]);
            }
        }
        setEquipmentName(location.state?.equipmentName);
    }, [equipmentNotes]);

    useEffect(() => {
        if (equipment?.equipmentFiles) {
            setEquipmentFiles(equipment.equipmentFiles);
            setIsDocumentPopupOpen(true);
            equipment.equipmentFiles = null;
        }
    }, [equipment]);

    const LoadHandler = () => {
        let lastRowsPerPage = rowsPerPage;
        LoadDataHandler(0, lastRowsPerPage);
    };

    // Load data handler
    const LoadDataHandler = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        var data = {
            equipmentId: location.state?.equipmentId,
            note: searchText,
        };

        let payload = {
            pageSize: pageSize,
            currentPage: pageNumber + 1,
            data: data,
        };
        dispatch(getEquipmentNotes(payload));
    };

    const [searchText, setSearchText] = useState("");
    const searchNote = (value, newpage) => {
        setSearchText(value.toLowerCase());
        LoadDataHandler(0, newpage);
    };

    const [filterText, setFilterText] = useState("");

    let filteredItems = rows.filter((item) => item.note.toLowerCase().includes(filterText));
    const handleSort = (row, column) => {
        setSortOrder(row);
        setSortColumn(column);

        var data = {
            equipmentId: location.state?.equipmentId,
            note: searchText,
            sortItem: {
                propertyName: column,
                direction: row,
            },
        };

        let payload = {
            pageSize: rowsPerPage,
            currentPage: currentPage + 1,
            data: data,
        };
        dispatch(getEquipmentNotes(payload));
    };

    //pagination
    const HandleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
        LoadDataHandler(newPage);
    };

    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        LoadDataHandler(0, +event.target.value);
        setCurrentPage(0);
    };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    const enableEditHandler = (row) => {
        console.log(currentPage);
        setRows(cloneObject(initialRows));
        setEditableRow(row.id);
        setEditable(true);
    };

    const disableEditHandler = () => {
        const oldRows = cloneObject(initialRows);
        setRows(oldRows);
        setEditable(false);
        //enable edit button
        setDisableButton(false);
    };

    const updateAddHandler = (row) => {
        if (row.id != null) {
            let data = {
                id: row.id,
                equipmentId: row.equipmentId,
                note: row.note,
                createDate: row.createDate,
                userId: userId,
                status: 1,
            };
            dispatch(updateEquipmentNote(data));
        } else {
            setDisableButton(false);

            let data = {
                equipmentId: row.equipmentId,
                equipmentName: row.equipmentName,
                note: row.note,
                createDate: new Date(row.createDate),
                userId: userId,
                status: 1,
            };
            dispatch(addEquipmentNote(data));
        }
        console.log(currentPage);
        LoadDataHandler(currentPage);
    };

    const addBlankRowHandler = () => {
        setCurrentPage(0);
        setDisableButton(true);

        let addedBlankRow = [
            {
                equipmentId: location.state?.equipmentId,
                equipmentName: equipmentName,
                note: "",
                createDate: new Date(),
            },
        ];

        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const deleteHandler = (row) => {
        toggleModal();
        dispatch(deleteEquipmentNote(row.id));
    };

    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 0 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`eqn_rowItems_TableCell_Actions_${index}_${item.id}`} align="right">
                        {t("Actions")}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`eqn_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`eqn_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => handleSort(sortOrder === 1 ? 0 : 1, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const goToBreakdownList = () => {
        props.history.push("/breakdownlist", { equipmentId: location.state?.equipmentId });
    };

    const goToPlannedList = () => {
        props.history.push("/planned-maintenance-task-list", { equipmentId: location.state?.equipmentId });
    };

    const getTitle = () => {
        if (isMobile) {
            return <h3>{location.state?.equipmentId + " / " + location.state?.equipmentName}</h3>;
        }
        return <h1>{location.state?.equipmentId + " / " + location.state?.equipmentName}</h1>;
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const showNoteDetails = (row) => {
        if (!editable) {
            setOpenDialog(true);
            setNoteDetails(row.note);
        }
    };

    // File Management
    const [equipmentFiles, setEquipmentFiles] = useState([]);
    const [equipmentIdForFileDelete, setEquipmentIdForFileDelete] = useState(0);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    const HandleDocumentPopupOpen = (id) => {
        setEquipmentIdForFileDelete(id);
        dispatch(getEquipmentFiles(id));
    };

    const DeleteEquipmentFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            equipmentId: equipmentIdForFileDelete,
            fileNames: selectedFileNames,
        };
        dispatch(deleteEquipmentFiles(payload));
        setIsDocumentPopupOpen(false);
    };

    return (
        <StyledTableDiv style={{ margin: "10px" }}>
            {getTitle()}
            <AddButton onClick={addBlankRowHandler} disabled={disableButton} />
            <Grid container marginBottom={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={8} sm={10} md={4}>
                    <SearchBar value={searchText} onChange={(newValue) => setSearchText(newValue)} onRequestSearch={(value) => searchNote(value)} />
                </Grid>
                <Grid item xs={3} sm={1} md={4}>
                    <Tooltip title={t("ShowFiles")}>
                        <IconButton size="large" onClick={() => HandleDocumentPopupOpen(location.state?.equipmentId)}>
                            <CloudDownload fontSize="large" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {renderTableCell([
                                    { id: "Note", label: t("Note") },
                                    { id: "CreateDate", label: t("CreatedDate") },
                                    { id: "Actions", label: t("Actions") },
                                ])}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredItems.slice(0, rowsPerPage).map((row) => (
                                <TableRow >
                                    <TableCell align="center" className="cellStyle">
                                        {editable && editableRow === row.id ? (
                                            <TextField id="equipmentNote" fullWidth onInput={(e) => setRowHandler(e.target.value, "note", row)} defaultValue={row.note} variant="outlined" />
                                        ) : (
                                            <>
                                                {row.note.length >= 20 ? row.note.slice(0, 25) + "..." : row.note}
                                                {row.note.length >= 20 ? <FcInfo onClick={() => showNoteDetails(row)} /> : null}
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell align="center" className="cellStyle">
                                        {moment(row.createDate).format("YYYY-MM-DD")}
                                    </TableCell>
                                    <TableButtons
                                        editable={editable}
                                        editableRow={editableRow}
                                        row={row}
                                        updateAddHandler={() => updateAddHandler(row)}
                                        enableEditHandler={() => enableEditHandler(row)}
                                        disableEditHandler={() => disableEditHandler()}
                                        deleteButtonHandler={() => deleteButtonHandler(row)}
                                    />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={rowsLength}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={HandleChangePage}
                        onRowsPerPageChange={HandleChangeRowsPerPage}
                    />
                </TableContainer>
            </Grow>
            <Grid container>
                <Grid item xs={6} sm={3} md={6}>
                    <Button
                        className={classes.root}
                        style={{ visibility: rows.length > 0 ? "visible" : "hidden" }}
                        id="eqn_breakdownlist"
                        onClick={() => goToBreakdownList()}
                        variant="contained"
                        color="primary"
                        size="small"
                    >
                        {t("BreakdownMaintenanceList")}
                        <ArrowForwardIos fontSize="small" />
                    </Button>
                </Grid>
                <Grid item xs={6} sm={3} md={6}>
                    <Button
                        className={classes.root}
                        style={{ visibility: rows.length > 0 ? "visible" : "hidden" }}
                        id="eqn_plannedlist"
                        onClick={() => goToPlannedList()}
                        variant="contained"
                        color="primary"
                        size="small"
                    >
                        {t("PlannedList")}
                        <ArrowForwardIos fontSize="small" />
                    </Button>
                </Grid>
            </Grid>
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="md_DialogDesc" style={{ overflow: "hidden", wordWrap: "break-word" }}>
                        {noteDetails}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => deleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={toggleModal} />

            {isDocumentPopupOpen === true ? (
                <DocumentPopup
                    id="eq_documentPopup"
                    isMaintenanceDocuments={false}
                    isEquipmentDocuments={true}
                    list={[]}
                    equipmentDocuments={equipmentFiles}
                    open={isDocumentPopupOpen}
                    deleteFile={null}
                    deleteEquipmentFiles={DeleteEquipmentFile}
                    close={() => setIsDocumentPopupOpen(false)}
                />
            ) : null}

            <LoadingBackdrop id="eqn_LoadingBackdrop" />
        </StyledTableDiv>
    );
}
